<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'financeAccountEdit',
    components: {
      baseEdit,
    },
  };
</script>
